import { defineComponent } from "vue";
import { saveSystem, updateSystem, loadSystem, deleteSystem } from "@/store/system/actions";
import { SdkSystem } from "@/interfaces/sdk-system";
import { INotification, ETypeNotification } from "@/interfaces/i-notification";
import { EventBus } from "@/utils/event-bus";

export default defineComponent({
  name: "sdk-forms-system-single",
  data() {
    return {
      loading: false,
      systemformData: { name: "", version: "" } as SdkSystem,
      newRecord: false,
      notification: [] as INotification[],
    };
  },
  computed: {
    isFormFilled(): boolean {
      return this.systemformData.name !== "" && this.systemformData.version !== "";
    },
  },
  methods: {
    async fetchSystem() {
      this.systemformData = { name: "", version: "" };
      const { system } = this.$route.params;
      if (system === "new") {
        this.systemformData = { name: "", version: "" };
        this.newRecord = true;
      } else {
        this.$dispatch(loadSystem)([system]).then((data: SdkSystem) => {
          this.systemformData = data;
        });
      }
    },
    async save() {
      if (this.systemformData.name !== "") {
        await this.$dispatch(saveSystem)([this.systemformData], this.$t("forms.systemsItem.notifications.save.success")).then(() => {
          this.endCreation();
        });
      } else {
        this.notification.push({
          type: ETypeNotification.DANGER,
          title: this.$t("forms.systemsItem.notifications.error.warning") as string,
          message: this.$t("forms.systemsItem.notifications.error.message") as string,
        });
        EventBus.$emit("emmit-notification", this.notification[0]);
        this.notification = [];
      }
    },
    async update() {
      if (this.systemformData.name !== "") {
        await this.$dispatch(updateSystem)([this.systemformData], this.$t("forms.systemsItem.notifications.update.success")).then(() => {
          this.endCreation();
        });
      } else {
        this.notification.push({
          type: ETypeNotification.DANGER,
          title: this.$t("forms.systemsItem.notifications.error.warning") as string,
          message: this.$t("forms.systemsItem.notifications.error.message") as string,
        });
        EventBus.$emit("emmit-notification", this.notification[0]);
        this.notification = [];
      }
    },
    async del() {
      await this.$dispatch(deleteSystem)([this.$route.params.system], this.$t("forms.systemsItem.notifications.delete.success")).then(() => {
        this.endCreation();
      });
    },
    endCreation() {
      this.$router.push({ name: "systems" });
    },
  },
  mounted() {
    this.fetchSystem();
  },
});
